import { useEffect, useState } from 'react';

// Services
import billingService from '../../services/billingService';

//Hooks
import useUser from "../user/useUser"

const defaultFilters = {
    pageSize: 10,
    pageNumber: 1,
}

const useInvoices = ( filters = defaultFilters) => {
    const { branch } = useUser();
    const [searchResult, setSearchResult] = useState({
        invoices: [],
        totalPage: 0
    })
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getInvoicesFromServer = () => {
            setLoading(true);

            let paymentMethods = [];

            if( filters.paymentMethods ) {
                paymentMethods = Array.isArray(filters.paymentMethods) 
                    ? filters.paymentMethods 
                    : [filters.paymentMethods]
            }

            billingService
                .SearchInvoices({
                    ...filters,
                    paymentMethods,
                    sellerCode: filters.sellerCode ? `${filters.sellerCode}` : null,
                    branchCode: branch.code
                })
                .then(res =>
                    setSearchResult({
                        invoices: res.values,
                        totalPage: res.totalPage
                    }))
                .finally(() => setLoading(false));
        }
        
        if (!loading && !!branch.code && filters && filters.channel) 
            getInvoicesFromServer()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, branch.code])

    return {
        ...searchResult,
        loading,
        filters
    }
}

export default useInvoices;